import React, { useEffect } from 'react'

const AI = () => {
  useEffect(() => {
    // Get the development token from localStorage
    const developmentToken = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY)
    
    if (developmentToken) {
      window.location.href = `https://backend.anatomicportal.com/user/login/${developmentToken}`
    } else {
      console.error('Development token not found in localStorage')
      // Optionally, you can redirect to a login page or show an error message
    }
  }, [])

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <h2>Redirecting to AI Authentication...</h2>
      <p>Please wait while we authenticate your session.</p>
    </div>
  )
}

export default AI
